import { render } from "./BaseTableRow.vue?vue&type=template&id=723ec4e3"
import script from "./BaseTableRow.vue?vue&type=script&lang=js"
export * from "./BaseTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__